const pino = require('pino')

function create() {
  const logger = pino({
    enabled: process.env.NO_LOGS !== 'true',
  })
  return logger
}

module.exports = create()
